import moment from 'moment';

export const isArrayPopulated = (array) => {
  return array && array.length > 0;
};

export const isValueLessThanMin = (min, value) => {
  if (value === 0) {
    return true;
  }

  return value && value < min;
};

export const isValueGreaterThanMax = (max, value) => {
  return value && value > max;
};

export const isValueInRange = (min, max, value) => {
  return value && !isValueLessThanMin(min, value) && !isValueGreaterThanMax(max, value);
};

const getMinutesOfDay = (momentDateTime) => {
  return momentDateTime.minutes() + momentDateTime.hours() * 60;
};

export const isTimeLessThanMinTime = (min, value, timeFormat) => {
  const minTime = moment(min, timeFormat).seconds(0);
  const time = moment(value, timeFormat).seconds(0);

  return minTime && time && getMinutesOfDay(time) < getMinutesOfDay(minTime);
};

export const isTimeGreaterThanMaxTime = (max, value, timeFormat) => {
  const maxTime = moment(max, timeFormat).seconds(0);
  const time = moment(value, timeFormat).seconds(0);

  return maxTime && time && getMinutesOfDay(time) > getMinutesOfDay(maxTime);
};
